import type { NavIcon } from "../nav";

const PATHS: Record<NavIcon | "search" | "people", string> = {
  shows: "M4 5h16v14H4zM4 9h16M9 5v14",
  upcoming: "M5 6h14v13H5zM5 10h14M9 3v4M15 3v4",
  roster: "M4 6h16M4 12h16M4 18h10",
  stats: "M5 20V11M12 20V5M19 20v-7",
  search: "M11 18a7 7 0 100-14 7 7 0 000 14zM21 21l-4.3-4.3",
  people: "M9 11.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM2.5 20c1-3.5 3.8-5 6.5-5s5.5 1.5 6.5 5M17 12a2.5 2.5 0 100-5M16 14.5c2.5 0 4.6 1.3 5.5 4",
};

export function Icon({ name }: { name: keyof typeof PATHS }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d={PATHS[name]} />
    </svg>
  );
}
